import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";

const VRIJWILLIGERS_HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/1fkaxwrb_Kopie%20van%20516872348_18014814209749830_9019666387714421357_n.jpg";

const VRIJWILLIGERS_GALLERY = [
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/0snyog0w_WhatsApp%20Image%202026-06-08%20at%2003.32.11.jpeg",
    alt: "Vrijwilligers van Mechelen Beach in actie achter de bar",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/efru2qjq_WhatsApp%20Image%202026-06-08%20at%2003.32.11%20%281%29.jpeg",
    alt: "Vrijwilligers van Mechelen Beach tappen frisse drankjes",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/1cojx52j_WhatsApp%20Image%202026-06-08%20at%2003.32.11%20%282%29.jpeg",
    alt: "Het Mechelen Beach vrijwilligersteam tijdens het evenement",
  },
];

export default function Vrijwilligers() {
  return (
    <>
      <Seo
        title="Vrijwilligers | Mechelen Beach 2026"
        description="Wil jij meehelpen aan Mechelen Beach 2026 als individu of met je vereniging? Neem contact op met de organisatie."
      />

      <PageHero
        eyebrow="Doe mee"
        title="Vrijwilligers"
        subtitle="Word deel van het Mechelen Beach team en help mee om er een onvergetelijke zomer van te maken."
        image={VRIJWILLIGERS_HERO_IMAGE}
        imageAlt="Vrijwilliger van Mechelen Beach tapt een frisse pint achter de bar"
        primaryCta={{ label: "Neem contact op", to: "/contact" }}
        secondaryCta={{ label: "Bekijk programma", to: "/programma" }}
      />

      <section
        data-testid="vrijwilligers-in-actie"
        className="bg-sand-2 py-16 sm:py-20"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl">
            <span className="eyebrow">Sfeerbeelden</span>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl font-semibold tracking-tight text-[#2b1c10]">
              Vrijwilligers in actie
            </h2>
            <p className="mt-4 text-base text-[#6b5945] leading-relaxed">
              Onze vrijwilligers maken het verschil — van de bar tot het strand.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
            {VRIJWILLIGERS_GALLERY.map((img) => (
              <div
                key={img.src}
                className="rounded-2xl overflow-hidden border border-[#ebd9b5] shadow-[0_14px_36px_-18px_rgba(43,28,16,0.25)] bg-white"
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  className="w-full h-[260px] sm:h-[300px] object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#fdf8ec] py-16 sm:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-6 text-base sm:text-lg text-[#6b5945] leading-relaxed">
            <p>
              Elk jaar zetten heel wat vrijwilligers zich in voor Mechelen Beach. Wil jij meehelpen
              aan de organisatie als individu of met je vereniging?
            </p>
            <p>
              Ook een activiteit bij ons organiseren is mogelijk. Hoe meer er te beleven valt, hoe
              leuker we het vinden.
            </p>
            <p>Neem contact met ons op om de mogelijkheden te bekijken.</p>
          </div>

          <div className="mt-10">
            <Link to="/contact" data-testid="vrijwilligers-cta" className="btn-primary">
              Neem contact op
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
